var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeopleUpperBody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 144,
    viewBox: "0 0 150 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.874 65.8851C101.492 64.8439 100.382 62.521 98.7072 60.1523C98.4892 59.8399 98.5841 59.7383 98.3413 58.9938C98.1183 58.1598 98.2822 57.7282 98.2063 57.1934C98.1694 56.9336 98.2057 56.6097 98.2063 56.1819C98.2063 55.984 97.525 56.1185 96.918 55.7896C96.4548 55.5387 96.0456 54.8155 95.9512 54.6668C95.4198 53.8064 95.4252 52.6232 95.4682 51.5327C95.5011 50.9444 95.5726 50.4751 95.9512 50.0378C96.0719 49.9025 93.8196 50.055 91.606 50.1903C91.606 50.0378 91.7079 59.6155 96.4451 63.9638C98.7072 66.0402 99.4494 67.818 103.198 67.6983C102.814 67.6983 105.479 67.8026 105.028 67.5705C104.836 67.4718 104.258 66.7648 104.064 66.7493C103.627 66.7181 103.339 66.2339 102.874 65.8851Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.08 49.5343C129.669 49.758 128.786 48.7663 128.309 49.5343C127.323 51.1213 127.058 53.9054 126.458 55.9058C126.447 55.9428 126.357 55.8033 126.346 55.8397C126.264 56.1216 126.142 55.8475 126.142 56.0158C126.142 56.3745 126.132 56.3955 126.142 56.7499C126.142 56.7636 126.142 57.015 126.142 57.1478C126.142 57.2807 125.912 57.5358 125.862 57.6419C125.784 57.8067 125.546 58.628 125.473 58.7806C123.49 62.8743 123.51 63.1326 120.271 67.0418C120.012 67.3542 118.295 68.2401 118 68.3237L119.778 68.2678C120.61 68.1923 121.442 68.0475 122.26 67.8923C123.106 67.7316 123.937 67.5598 124.736 67.442C126.598 67.1676 128.288 67.1865 129.604 68.3237C129.604 68.3237 132.37 56.5386 132.497 50.2651C132.499 50.1389 131.747 49.6556 131.747 49.5343C130.029 49.4187 130.278 49.4187 130.08 49.5343Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.5 50.2001H129.2C116.6 46.0001 101.2 29.5001 101.2 29.5001C101.2 29.5001 116.3 26.9001 123.5 30.4001C130.7 33.9001 132.5 50.2001 132.5 50.2001Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.1 32.3002C106.1 32.3002 101.599 44.768 97.4938 49.1746C97.3607 49.3174 97.1441 49.2544 97 49.4002L91.6 50.1002C91.6 50.1002 93.9 38.7002 97.4 34.9002C100.9 31.1002 106.1 32.3002 106.1 32.3002Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8 36.4002L57.2 44.2002C57.2 44.2002 48.5 52.4002 44.2 52.4002C39.9 52.4002 31.2 44.2002 31.2 44.2002L30.6 35.2002",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 30.2002C59.5 30.2002 61.7001 27.3002 61.7001 30.8002C61.7001 34.3002 60.5 36.9002 58.8 36.9002",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6 36.9002C27.9 36.9002 26.8 34.3002 26.8 30.8002C26.8 27.3002 29 30.2002 29 30.2002",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 23.4001L58.1 31.2001",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2 30.2002L30.1 23.2002",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2 37.7001C43.4007 37.9735 43.6937 38.1647 44.0248 38.2383C44.3558 38.3118 44.7024 38.2627 45 38.1001C46.1 37.7001 45.0999 32.1001 45.0999 32.1001",
    stroke: "#1F323D",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4 31.9002C38.4 32.9002 38.2 33.7002 37.9 33.7002C37.6 33.7002 37.4 32.9002 37.4 31.9002C37.4 30.9002 37.6 30.2002 37.9 30.2002C38.2 30.2002 38.4 31.0002 38.4 31.9002Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.315864
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5 31.9002C51.5 32.9002 51.3 33.7002 51 33.7002C50.7 33.7002 50.4 32.9002 50.4 31.9002C50.4 30.9002 50.7 30.2002 51 30.2002C51.3 30.2002 51.5 31.0002 51.5 31.9002Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.315864
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 27.3001C41 28.3001 36.7 27.4001 35.7 27.5001C34.7 27.6001 32.6 28.7001 32.5 28.6001C33.2001 27.7159 34.0882 26.9985 35.1 26.5001C36.2 26.2001 41 26.3001 41 27.3001Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.157932
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1 28.6001C56 28.7001 53.8 27.7001 52.9 27.5001C52 27.3001 47.6 28.3001 47.6 27.3001C47.6 26.3001 52.4 26.2001 53.5 26.5001C54.5301 26.9692 55.4246 27.6917 56.1 28.6001Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.157932
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7 131.2L14.8 67.5L28.5 57.8L44.3 89.3001V131.2H18.7Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.8001 67.5L69.9001 131.2H44.3V89.3001L60.1 57.8L73.8001 67.5Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1 23.1001L24.5 22.8001C24.5 21.4001 27.5 19.2001 27.5 19.2001C27.4 11.5001 31.8 3.1001 41.4 3.1001H47.3C56.8 3.1001 61.2 11.5001 61.1 19.2001C61.1 19.2001 64.1 21.4001 64.1 22.8001V23.1001Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.3 105V141.2H88.2L91.5 126.4L88.9 84.6001L99.1 78.9001L112.3 105Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.6 84.2002L133.1 126.4L136.4 141.2H112.3V105L125.2 78.7002L135.6 84.2002Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.5001 39.8C94.4001 31.8 100.2 23.5 110.2 23.5H114.6C124.5 23.5 130.3 31.8 130.3 39.8H94.5001Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.6 43.9001H90.5L94.5 39.8H130.2L134.6 43.9001Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7 67.2002C10.4 70.5002 5.29999 75.8002 3.39999 81.8002C-1.50001 97.7002 2.59999 118.2 2.59999 118.2L67.5 99.9002",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6 47.1001C32.6 52.0001 31.5 53.9001 30.4 55.5001",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5001 99.9C67.5001 99.9 63.9001 92.2 66.4001 86.3",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24 97.2002C44.8 90.6002 65.6 97.2002 65.6 97.2002",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1001 95.5001C21.2001 96.2001 15.8001 100.7 15.4001 99.3001C15.0001 97.9001 19.9001 94.1001 24.0001 93.4001",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4 91.2002C19.4 91.9002 14.1 96.4002 13.7 95.1002C13.3 93.8002 18.2 89.9002 22.2 89.2002",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1 86.9C18.1 87.6 12.7 92.1 12.4 90.7C12.1 89.3 16.8 85.5 20.9 84.8",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6 57.8001L58 55.4001C57 53.8001 55.9 51.9001 55.9 47.1001",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3 81.8002C83.4 75.8002 78.3 70.5002 74 67.2002",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4 107.3L74 115.9",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4 86.3V93.9",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4 107.6V133.3",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 60.1C50.0926 61.7762 47.2334 62.6827 44.3 62.7C35.7 62.7 31.4 55 31.4 55",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8 10.2001V1.1001H46.8V10.2001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4 13.7002L32.4 16.3002V18.2002",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2 18.6002V16.3002L62.2 13.7002",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8 42.7002C41.0769 43.4468 42.5214 43.8595 44 43.9002",
    stroke: "#1F323D",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M133.7 115.4C133.7 115.4 130.9 108.5 130.9 103.3",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4 113.8C108.065 110.425 120.412 110.184 132.2 113.1",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 112.2C94.1 112.6 89.1 115.8 88.9 114.6C88.7 113.4 93.2 110.5 96.7 110.3",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4 108.3C92.9 108.5 87.9 111.8 87.7 110.6C87.5 109.4 92 106.6 95.5 106.4",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5 104.3C92 104.5 87 107.9 86.8 106.7C86.6 105.5 91.1 102.6 94.7 102.4",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M125.8 78.7001L122.9 76.9001C120.692 74.4244 119.48 71.2175 119.5 67.9001",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M107.5 122L149 130.7C149 130.7 144.6 92.5002 141.9 88.9002C140.28 86.7718 138.237 85.0014 135.9 83.7002",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3 83.2002C86.6008 84.5575 84.2424 86.5058 82.4 88.9002C79.7 92.5002 75.3 130.7 75.3 130.7L133.4 115.4",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M104.9 67.9001C104.92 71.2175 103.708 74.4244 101.5 76.9001",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M118.4 82.3001C116.783 83.929 114.595 84.862 112.3 84.9001C105.4 84.9001 102.5 76.9001 102.5 76.9001",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 122.8V143.5",
    stroke: "#1F323D",
    strokeWidth: 0.634886
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 101.8V110.7",
    stroke: "#1F323D",
    strokeWidth: 0.634886
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M109.8 30.0001V21.4001H115V30.0001",
    stroke: "#1F323D",
    strokeWidth: 0.616922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4 34.1001L99.6 36.8001V39.1001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M125.1 39.6001V36.8001L131.3 34.1001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.6 52.6001C106.6 53.5001 106.4 54.2001 106.1 54.2001C105.8 54.2001 105.6 53.5001 105.6 52.6001C105.6 51.7001 105.8 50.9001 106.1 50.9001C106.4 50.9001 106.6 51.7001 106.6 52.6001Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.317433
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.1 52.6001C119.1 53.5001 118.9 54.2001 118.6 54.2001C118.3 54.2001 118.1 53.5001 118.1 52.6001C118.1 51.7001 118.3 50.9001 118.6 50.9001C118.9 50.9001 119.1 51.7001 119.1 52.6001Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.317433
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.5 48.2002C109.5 49.0002 104.9 48.2002 104.2 48.4002C103.5 48.6002 101.5 49.4002 101.4 49.3002C101.956 48.5111 102.716 47.8887 103.6 47.5002C104.6 47.2002 109.5 47.3002 109.5 48.2002Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.141814
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123 49.3001C123 49.4001 121.1 48.5001 120.3 48.4001C119.5 48.3001 114.9 49.0001 114.9 48.2001C114.9 47.4001 119.9 47.2001 120.8 47.5001C121.7 47.8001 123.1 49.1001 123 49.3001Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.141767
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M108.7 62.9001C109.895 63.7378 111.346 64.1273 112.8 64.0001",
    stroke: "#1F323D",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M111.1 58.3C111.314 58.5242 111.589 58.6814 111.891 58.7524C112.192 58.8234 112.508 58.8052 112.8 58.7C113.9 58.3 113.4 55 113.4 55",
    stroke: "#1F323D",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.1 49.1C126.1 49.1 128.3 49 128.3 52.1C128.3 55.2 127.1 55.9 125.5 55.9",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M126.069 48.9841C126.069 48.9841 128.3 49.0002 128.3 52.1002C128.3 55.2002 127.285 55.891 125.685 55.891",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M126.1 55.9001L125.2 60.2001C122.387 65.2703 117.733 69.0652 112.2 70.8001C106.657 69.0838 101.997 65.2838 99.2 60.2001L98.1 53.9001",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.2 55.9001C96.6 55.9001 95.3 55.3001 95.3 52.1001C95.3 48.9001 97.7 49.1001 97.7 49.1001",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2 55.9002C96.6 55.9002 95.3 55.3002 95.3 52.1002C95.3 48.9002 97.3351 49.1002 97.7 49.1002L98.3646 48.0979",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleUpperBody);
export default __webpack_public_path__ + "static/media/people_upper_body.929de1de7355595dd3c41149d080d558.svg";
export { ForwardRef as ReactComponent };